import { DataResult } from "@progress/kendo-data-query";
import { faCancel } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import _ from "lodash";
import { DATA_ITEM_KEY } from "../../../../Grid/GridConstants";
import PageMenuItem from "../../../../Layout/PageMenu/PageMenuItem";
import StyledPageMenuIcon from "../../../../Layout/PageMenu/PageMenuIcon";
import { PdsrValidationItemEditMode } from "../PdsrValidationItemGrid";

interface Props {
  readonly dataResult: DataResult;
  readonly setDataResult: (dataResult: DataResult) => void;
  readonly setEditMode: (editMode: PdsrValidationItemEditMode) => void;
}

export default function CancelCreateButton({ dataResult, setDataResult, setEditMode }: Props) {
  const handleClick = () => {
    const data = dataResult.data.filter((item) => {
      return _.get(item, DATA_ITEM_KEY);
    });

    setDataResult({
      data,
      total: data.length,
    });

    setEditMode(PdsrValidationItemEditMode.Update);
  };

  return (
    <PageMenuItem align="left" onClick={() => handleClick()} type="link">
      <StyledPageMenuIcon icon={faCancel} />
      Cancel
    </PageMenuItem>
  );
}
